import { render, staticRenderFns } from "./StarterGalleryModal.vue?vue&type=template&id=4ff26762&scoped=true"
import script from "./StarterGalleryModal.vue?vue&type=script&lang=js"
export * from "./StarterGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./StarterGalleryModal.vue?vue&type=style&index=0&id=4ff26762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff26762",
  null
  
)

export default component.exports